import { THREE_PI_PROPERTY_CATEGORIES } from '@/config/three-pi-property-categories.js';

const MAX_STAR_RATING = 5;

function getThreePiPropertyCategory(propertyCategory) {
  return THREE_PI_PROPERTY_CATEGORIES[propertyCategory?.toUpperCase()]
    || THREE_PI_PROPERTY_CATEGORIES.OTHER;
}

export function getThreePiCategoryTheme(propertyCategory) {
  return getThreePiPropertyCategory(propertyCategory).theme;
}

export function getThreePiTypeLabel(property, t) {
  const category = getThreePiPropertyCategory(property?.propertyCategory);
  const starRating = Number.parseInt(property?.starRating, 10);
  const stars = Number.isInteger(starRating) && starRating > 0
    ? ` ${'★'.repeat(Math.min(starRating, MAX_STAR_RATING))}`
    : '';

  return `${t(category.transcode)}${stars}`;
}
